<script>
    /*
    	LandingPageTextButton.svelte
    */

    import { onMount } from 'svelte';

    // TCARE components

    // SMUI components


    export let label;
    export let onClick;
    
    onMount(() => {
    })

</script>

<style>
    .landing-page-text-button {
        min-width: 110px;
        padding: 10px 20px;
        margin-left: 10px;
        font-size: 16px;
        font-weight: 400;
        color: var(--tcare-white);
        background: none;
        border: none;
        border-radius: 25px;
    }

    .landing-page-text-button:hover {
        background-color: var(--tcui-secondary);
    }

    @media screen and (max-width: 600px) {
    }

    @media screen and (min-width: 601px) and (max-width: 1300px) {
    }

    @media screen and (min-width: 1201px) {
    }

</style>

<button class="landing-page-text-button" on:click={onClick}>
    {label}
</button>
